import { useEffect, useRef } from 'react'

export default function SectionWrapper({ id, children, className = '', bg = 'white' }) {
  const ref = useRef(null)

  const bgClass = bg === 'alt' ? 'bg-surface-50' : 'bg-surface-0'

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll('.fade-in-up')
            items.forEach((item, i) => {
              setTimeout(() => item.classList.add('is-visible'), i * 100)
            })
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.08 }
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <section
      id={id}
      ref={ref}
      className={`py-20 md:py-28 ${bgClass} ${className}`}
    >
      {children}
    </section>
  )
}
